<template>
	<tbody>
    <tr v-for="(item, i) in items" :key="item.id" class="text-xs-left">
      <td class="text-xs-center">
        <v-icon x-large class="k-orange-linear-text text--darken-2">cloud_download</v-icon>
      </td>
      <td>
        {{ item.user.first_name }} {{ item.user.last_name }}
        <small>{{ item.user.email }}</small>
      </td>
      <td>
        <v-layout justify-center align-center>
          <v-flex md9>
            {{ item.name }}
          </v-flex>
          <v-flex md3>
            <v-btn icon large class="k-orange-linear-text" :disabled="!item.url" @click="downloadFile(item)">
              <v-icon>fas fa-download</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </td>
      <td>
        <small>Fecha de descarga</small>
        {{ formatDate(item.created_at, 'DD/MM/YYYY') }}
      </td>
      <td>
        <v-tooltip bottom
          v-if="item.status === 'Procesado'">
          <v-icon
            slot="activator"
            color="green"
            large>
            fas fa-check-circle
          </v-icon>
          <span>Generado con exito</span>
        </v-tooltip>
        <v-tooltip bottom
          v-else-if="item.status === 'Procesando'">
          <v-icon
            slot="activator"
            color="blue"
            large>
            fas fa-spinner
          </v-icon>
          <span>Procesando</span>
        </v-tooltip>
        <v-tooltip bottom
          v-else>
          <v-btn
            @click="showError(item)"
            slot="activator"
            class="ma-0"
            icon>
            <v-icon
              color="red"
              large>
              fas fa-times-circle
            </v-icon>
          </v-btn>
          <span>Error</span>
        </v-tooltip>
      </td>
    </tr>
  </tbody>
</template>

<script>
import moment from 'moment';
import EventBus from '@/event-bus';

export default {
  props: ['items'],
  methods: {
    formatDate(date, dateFormat) {
      return moment(date, 'YYYY-MM-DD HH:mm:ss').format(dateFormat);
    },
    showError(item) {
      EventBus.$emit('showError', item.log);
    },
    downloadFile(report) {
      this.axios({
        url: `report_downloads/download/${report.id}`,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        if (!window.navigator.msSaveOrOpenBlob) {
          // BLOB NAVIGATOR
          const url = window.URL.createObjectURL(response.data);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', report.name);
          document.body.appendChild(link);
          link.click();
        } else {
          // BLOB FOR EXPLORER 11
          window.navigator.msSaveOrOpenBlob(response.data, report.name);
        }
      });
    },
  },
  data() {
    return {
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/report_download/ReportDownloadList.vue